
export default {
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      currentTab: 0,
    };
  },
  computed: {
    tabNavItems () {
      return this.tabs.length ? this.tabs.map(tab => tab.title) : [];
    },
    numberOfTabs () {
      return this.tabs.length;
    },
    lastTab () {
      return this.tabs.length - 1;
    },
    tabs () {
      return this.block.tabs;
    },
    hasAccordion () {
      return this.block.collapse_to_accordion;
    },
  },
  methods: {
    handleKeys (event) {
      if (event.key === `ArrowRight`) {
        if (this.currentTab === this.lastTab) {
          this.currentTab = 0;
        } else {
          this.currentTab++;
        }
      } else if (event.key === `ArrowLeft`) {
        if (this.currentTab === 0) {
          this.currentTab = this.lastTab;
        } else {
          this.currentTab--;
        }
      }
    },
  },
};
